import React from "react";
import { StyledStatusButton, StatusButtonProps } from "./styled";

export type PresenterProps = {
  text: React.ReactNode;
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
} & StatusButtonProps;

export const StatusButtonPresenter: React.FC<PresenterProps> = ({
  text,
  ...rest
}) => {
  return <StyledStatusButton {...rest}>{text}</StyledStatusButton>;
};
